import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Paper,
  Divider,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Box,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Hidden,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import { NavLink as RouterLink } from "react-router-dom";
import { history } from "../../components/helpers/History";
import { DoctorAction } from "../../redux/actions/DoctorAction";
import SearchDoctorCardView from '../doctor/search/SearchDoctorCardView'
import { AppConstants } from "../../components/constants/ApplicationConstants";

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class BookNewAppointmentInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appointmentInfo: {
        consultationType: "",
        startDateTime: this.props.startDateTime,
        description: "",
        status: "",
        doctorId : this.props.doctorId
      },
      submitted: false,
    };
  }

  componentDidMount(){
    this.props.getDoctorById(this.props.doctorId);
  }

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>Patient portal | Book New appointment</title>
        </Helmet>
        <Container component="main" maxWidth="sm">
          <CssBaseline />
          <Paper className={classes.paper}>
            {(this.props.doctor&& this.props.doctor.firstName )?
            <SearchDoctorCardView showBookNowBtn ={false} doctor={this.props.doctor} />:null}
            <Formik
              enableReinitialize
              initialValues={{
                consultationType: this.state.appointmentInfo.consultationType,
                startDateTime: this.state.appointmentInfo.startDateTime,
                description: this.state.appointmentInfo.description,
                status: "BOOKED",
              }}
              validationSchema={Yup.object().shape({
                description: Yup.string()
                  .max(300)
                  .required("Description is required"),
                consultationType: Yup.string()
                  .ensure()
                  .required("Consultation type is required"),
              })}
              onSubmit={(values, { setSubmitting }) => {
                this.props.handleAppointment(values);
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                values,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  className={classes.form}
                  noValidate
                  name="form"
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <Typography variant="body2" color="textSecondary">
                        Appointment Date & Time : {values.startDateTime}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        fullWidth
                      >
                        <InputLabel htmlFor="consultationType-label">
                          Consultation type
                        </InputLabel>
                        <Select
                          native
                          value={values.consultationType}
                          error={Boolean(
                            touched.consultationType && errors.consultationType
                          )}
                          helperText={
                            touched.consultationType && errors.consultationType
                          }
                          label="Consultation type"
                          inputProps={{
                            name: "consultationType",
                            id: "consultationType-label",
                          }}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          <option aria-label="None" value="" />
                          {AppConstants.SPECIALITIES_LIST.map((element) => {
                              return(<option value={element.name}>
                                {element.name}
                              </option>)
                            })}
                        </Select>
                        {errors.consultationType && touched.consultationType && (
                          <FormHelperText style={{ color: "#f44336" }}>
                            {errors.consultationType}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        error={Boolean(touched.description && errors.description)}
                        fullWidth
                        multiline
                        rows={4}
                        helperText={touched.description && errors.description}
                        label="Description"
                        margin="normal"
                        name="description"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.description}
                        variant="outlined"
                      />
                    </Grid>
                    
                  </Grid>

                  <div className={classes.buttons}>
                    <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      onClick={() => {
                        if(this.props.handleBack){
                          this.props.handleBack();
                        }else{
                          history.goBack();
                        }
                        
                      }}
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      disabled={this.state.submitted}
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
          </Paper>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const doctor = state.doctor.profile;
  return {doctor };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDoctorById: (id) => {
      dispatch(DoctorAction.getDoctorById(id));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(BookNewAppointmentInput));
